// The System Identification screen used to store a button index (0=create,
// 1=edit, 2=confirm, 3=save) as its mode. Mode is now an explicit string and
// the integer is derived here, so SettingsMain's create-vs-update service
// branching and every child component keep working on the values they expect.
export const SYS_ID_MODES = {
  ADD: 'add',
  EDIT: 'edit',
};

export const sysIdModeToFlag = (mode) => {
  if (mode === SYS_ID_MODES.ADD) return 0;
  if (mode === SYS_ID_MODES.EDIT) return 1;
  return null;
};
